
























































































































import { Component, Vue, Inject, Prop } from "vue-property-decorator";
import AbpBase from "@/lib/abpbase";
import Account from "@/store/entities/account";
import md5 from "js-md5";
@Component
export default class BindCloud extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;
  platformSource: number = 0;
  user: Account = new Account();
  password: string = "";
  homes: Array<any> = null;
  currentHome: any = {};
  rooms: Array<any> = [];
  currentRoom: any = "";
  officeid: number = null;

  init(officeid: number) {
    this.officeid = officeid;
  }

  async handleSubmit() {
    this.user.platformSource = this.platformSource;
    if (this.platformSource == 2) this.user.password = md5(this.password);
    else this.user.password = this.password;
    this.homes = await this.$store.dispatch({
      type: "cloud/login",
      data: this.user,
    });
    (this.$refs.accountForm as any).resetFields();
  }
  async save() {
    var room =
      this.platformSource == 1
        ? this.rooms.find((x) => x.id == this.currentRoom)
        : this.rooms.find((x) => x.room_id == this.currentRoom);
    this.$store.dispatch({
      type: "cloud/bind",
      data: {
        officeid: this.officeid,
        homeid:
          this.platformSource == 1
            ? this.currentHome.id
            : this.currentHome.home_id,
        homename: this.currentHome.name,
        roomid: this.currentRoom,
        roomname: room.name,
        platformSource: this.platformSource,
      },
    });
    this.$emit("input", false);
    this.homes = null;
    this.currentHome = {};
    this.rooms = [];
    this.currentRoom = "";
    this.password = "";
  }
  changePlatform(val: number) {
    this.platformSource = val;
  }
  async changeHome(value: any) {
    this.currentHome = value;
    if (this.platformSource == 1) {
      this.rooms = value.rooms;
    }
    if (this.platformSource == 2) {
      var res = await this.$store.dispatch({
        type: "cloud/getRooms",
        data: { homeid: value.home_id },
      });
      this.rooms = res.rooms;
    }
  }
  lastStep() {
    if (this.homes == null) {
      this.user = new Account();
      (this.$refs.accountForm as any).resetFields();
      this.platformSource = 0;
    } else {
      this.user = new Account();
      this.homes = null;
      this.currentHome = {};
      this.rooms = [];
      this.currentRoom = "";
      this.password = "";
    }
  }
  cancel() {
    if (this.platformSource != 0 && this.homes == null)
      (this.$refs.accountForm as any).resetFields();
    this.$emit("input", false);
  }
}
